<ng-template #errorModalTemplate id="errorModalTemplate">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ errorContent?.header }}</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h5 class="font-weight-normal">{{ errorContent?.body }}</h5>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="handleClose()">
      {{ 'GENERAL.MODAL_OK' | translate }}
    </button>
  </div>
</ng-template>
